/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


document.addEventListener('DOMContentLoaded', () => { 
  const item_plp = document.querySelectorAll('.material_item_plp');

  item_plp.forEach(item => { 
    item.addEventListener('mouseenter', () => {
      const id = item.dataset.id;
      const img = item.dataset.img;
      const price = item.dataset.price;
      const comparePrice = item.dataset.compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }
    });
    item.addEventListener('click', () => {
      const id = item.dataset.id;
      const img = item.dataset.img;
      const price = item.dataset.price;
      const comparePrice = item.dataset.compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }

    });
    item.addEventListener('mouseleave', () => {
      const id = item.dataset.id;
      const img = item.dataset.main_img;
      const price = item.dataset.main_price;
      const comparePrice = item.dataset.main_compare_price;
      const container = document.getElementById(id);
      if(container) {
        if (img!='') {
          const imgEl = container.querySelector('.product_item_image img');
          if(imgEl) {
            imgEl.src = img;  
          } 
        }
        if (price!='') {
          const priceEl = container.querySelector('.product_item_prices');
          let price_r='';
          if (comparePrice=='') {
            price_r=`<div class="product_price_main"><div class="regular">${price}</div></div>`;
          } else {
            price_r=`<div class="product_price_main product_price_main_sale"><div class="sale">${comparePrice}</div><div class="regular">${price}</div></div>`;
          }
          priceEl.innerHTML = price_r;
        }
      }  
    });
  });
});

function material_item_plp(id,url,price,compare_price) {
  console.log('1111')
  const container = document.getElementById(id);
  if(container) {
    if (url!='') {
      const imgEl = container.querySelector('.product_item_image img');
      if(imgEl) {
        imgEl.src = url;  
      } 
    }
  }
}

function slideDown(element, duration = 300) {
  element.style.height = '0px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  
  setTimeout(() => {
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
}
 
function slideUp(element, duration = 300) {
  const height = element.scrollHeight;
  element.style.height = height + 'px';
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms ease`;
  
  setTimeout(() => {
    element.style.height = '0px';
  }, 10);
  
  setTimeout(() => {
    element.style.display = 'none';
    element.style.height = '';
    element.style.overflow = '';
    element.style.transition = '';
  }, duration);
} 


document.addEventListener('click', function (e) {
  if (e.target.classList.contains('items_blocks__link_btn')) {
    e.preventDefault();
    document.querySelectorAll('.items_blocks__link').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.items_blocks__row_item').forEach(el => {
      el.style.display = 'block';
    });
  }
});



function playVideo(id) { 
    let video = document.getElementById("mp4-video-"+id); 
    let closeBtn = document.getElementById("close-btn-"+id);
    let playBtn = document.querySelector("#play-button-"+id);  
    closeBtn.style.display = "flex";
    playBtn.style.display = "none";  
    video.play(); 
  }


function stopVideoMp4(id) {  
    let video = document.getElementById("mp4-video-"+id); 
    let closeBtn = document.getElementById("close-btn-"+id);
    let playBtn = document.querySelector("#play-button-"+id);  
  closeBtn.style.display = "none";  
  playBtn.style.display = "block";   
  video.pause(); 
} 


document.addEventListener('click', function (e) {
  const title = e.target.closest('.sorting_item_title');
  if (!title) return;
  const item = title.closest('.sorting_item');
  if (!item) return;
  const content = item.querySelector('.sorting_item_dann');
  if (!content) return;
  content.classList.toggle('active');
});




document.addEventListener('click', function (e) {
  const filterLabel = e.target.closest('.main_filters_label');
  if (filterLabel) {
    e.preventDefault();
    const input = document.getElementById(filterLabel.getAttribute('for'));
    if (!input) return;
    input.checked = !input.checked;
    filterLabel.classList.toggle('active', input.checked);
    const activeSort = document.querySelector('.main_sorting_label.is-active');
  const sortBy = activeSort ? activeSort.dataset.sort : 'manual'; 
  updateCollection(sortBy);
    return;
  }

  const sortLabel = e.target.closest('.main_sorting_label');
  if (sortLabel) {
    const item = sortLabel.closest('.sorting_item');
    if (!item) return;
    const title = item.querySelector('.sorting_item_title');
    const dropdown = item.querySelector('.sorting_item_dann');
    if (title) title.textContent = sortLabel.textContent.trim();
    item.querySelectorAll('.main_sorting_label').forEach(el => el.classList.remove('is-active'));
    sortLabel.classList.add('is-active');
    if (dropdown) dropdown.classList.remove('active');
    updateCollection(sortLabel.dataset.sort);
  }
});

function updateCollection(sortBy) {
  const params = new URLSearchParams();

  document.querySelectorAll('.main_filters_label').forEach(label => {
    const input = document.getElementById(label.getAttribute('for'));
    if (input && input.checked) {
      params.append(input.name, input.value);
    }
  });

  if (sortBy) {
    params.set('sort_by', sortBy);
  }

  loadCollection(params);
}

function loadCollection(params) {
  const query = params.toString();
  const url = query
    ? `${window.location.pathname}?${query}`
    : window.location.pathname;

  fetch(url)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newLoop = doc.querySelector('#CollectionLoop');
      const currentLoop = document.querySelector('#CollectionLoop');
      if (newLoop && currentLoop) currentLoop.innerHTML = newLoop.innerHTML;
      history.pushState({}, '', url);
    });
}
 





document.addEventListener('DOMContentLoaded', () => {
  const plans = document.querySelectorAll('input[name="selling_plan"]');
  if (!plans.length) return;

  const params = new URLSearchParams(window.location.search);
  const sellingPlanFromUrl = params.get('selling_plan');

  let activated = false;
 
  if (sellingPlanFromUrl) {
    plans.forEach(plan => {
      if (plan.value === sellingPlanFromUrl) {
        plan.checked = true;
        activated = true;
      }
    });
  }

  if (!activated) {
    const indexToActivate = plans.length >= 3 ? 1 : 0;
    plans[indexToActivate].checked = true;
  }
 
  function updateUI() {
    const activePlan = document.querySelector('input[name="selling_plan"]:checked');
    if (!activePlan) return;

    const procentEl = document.getElementById('subs_procent');
    const priceEl = document.getElementById('subs_subscribe_price');
    const procent = activePlan.dataset.procent;

    if (procentEl && activePlan.dataset.procent !== undefined) {
      procentEl.textContent = procent;
    }

    const productContent = document.querySelector('.product__content'); 
    let variantId = null; 
    if (productContent) {
      const variantInput = productContent.querySelector('input[type="hidden"][name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }
    } 
    if (
  var_sub_price[variantId] &&
  var_sub_price[variantId][procent]
) {
  priceEl.innerHTML = var_sub_price[variantId][procent];
  }
}
 
  updateUI();
  
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="selling_plan"]')) {
      updateUI();
    }
  });
});
